import { Col, Row } from '@/components/grid/grid-component';
import styled from 'styled-components';

const MainRow = styled(Row)`
  margin: 0;
  padding: 24px;
`;

const SelectCol = styled(Col)`
  margin-top: 5px;
`;

const ButtonCol = styled(Col)`
  justify-content: 'right';
  display: 'flex';
`;

const StyledLink = styled.a`
  text-decoration: 'underline';
  position: 'relative';
`;

const StyledRedactorLink = {
  MainRow,
  SelectCol,
  StyledLink,
  ButtonCol,
};

export default StyledRedactorLink;
